// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyCardImage_image_graphql = require("../../__generated__/PropertyCardImage_image_graphql.bs.js");

var convertFragment = PropertyCardImage_image_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyCardImage_image_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyCardImage_image_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyCardImage_image_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyCardImage_image_graphql.node, convertFragment, fRef);
}

var ImageFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyCardImage(props) {
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  var image = use(props.image);
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("img", {
                    className: "w-full h-full object-cover absolute inset-0",
                    alt: "Property image",
                    src: image.url
                  }),
              className: TailwindMerge.twMerge([
                    "w-1/4 relative",
                    className
                  ])
            });
}

var make = PropertyCardImage;

exports.ImageFragment = ImageFragment;
exports.make = make;
/* tailwind-merge Not a pure module */
